import React from 'react';
import Box from '@mui/material/Box';
import { DataGrid } from '@mui/x-data-grid';

const ORDER_TYPE_LABELS = {
    paGG: "Grab & Go",
    paAssembly: "Assembly",
    ks: "Kitty Sift",
    petFactory: "Pet Factory",
    cancel: "OOS",
    discontinued: "Discontinued"
};

const columns = [
    {
        field: 'order_number',
        headerName: 'Order Number',
        flex: 1, 
        minWidth: 150,
        editable: false
    }, 
    {
        field: 'order_type',
        headerName: 'Order Type',
        flex: 1,
        minWidth: 75,
        valueGetter: (params) => {
            return ORDER_TYPE_LABELS[params.row.order_type] || params.row.order_type;
        },
        editable: false
    }, 
    {
        field: 'create_response',
        headerName: 'Uploaded Successfully',
        flex: 1,
        minWidth: 100,
        valueGetter: (params) => {
            if(params.row.create_response === 200) return "TRUE";
            else return "FALSE";
        }, 
        editable: false
    },
    {
        field: 'cancel_response',
        headerName: 'Canceled Successfully',
        flex: 1,
        minWidth: 100,
        valueGetter: (params) => {
            if(params.row.cancel_response === 200) return "TRUE";
            if(params.row.cancel_response > 400) return "FALSE";
            else return "N/A";
        }, 
        editable: false
    },
    {
        field:'acu_order_num',
        headerName: 'Acumatica Number',
        flex: 1,
        minWidth: 150,
        editable: false
    }
]

    function AmazonUploadTable(props) {
    return (
        <Box className={props.isMobile ? "mobile-box" : "desktop-box"} mt={3}>
        <Box
            className={props.isMobile ? "mobile-table-box" : "desktop-table-box"}
            sx={{ width: "100%" }}
        >
            <DataGrid
                className={props.isMobile ? "mobile-table" : "desktop-table"}
                sx={{ height: 600, width: "100%" }}
                rows={props.orders || []}
                columns={columns}
                pageSizeOptions={[25, 50, 100]}
                checkboxSelection={false}
                getRowId={(row) => `${row.order_number}_${row.order_type}`}
            />
        </Box>
        </Box>
    );
}

export default AmazonUploadTable;